'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _reactisForms = require('reactis-forms');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Glyphicon = require('./Glyphicon');

var _Glyphicon2 = _interopRequireDefault(_Glyphicon);

var _reactBootstrap = require('react-bootstrap');

var _components = {
	_$TextInput: {
		displayName: 'TextInput'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var TextInput = (function (_React$Component) {
	_inherits(TextInput, _React$Component);

	function TextInput() {
		_classCallCheck(this, _TextInput);

		_React$Component.apply(this, arguments);
	}

	TextInput.prototype.getError = function getError() {
		return this.props.error && this.props.error[0];
	};

	TextInput.prototype.renderInputGroup = function renderInputGroup(children) {
		var addonBefore = this.props.addonBefore ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-addon', key: 'addonBefore' },
			this.props.addonBefore
		) : null;

		var addonAfter = this.props.addonAfter ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-addon', key: 'addonAfter' },
			this.props.addonAfter
		) : null;

		var buttonBefore = this.props.buttonBefore ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-btn' },
			this.props.buttonBefore
		) : null;

		var buttonAfter = this.props.buttonAfter ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-btn' },
			this.props.buttonAfter
		) : null;

		var inputGroupClassName = undefined;
		switch (this.props.bsSize) {
			case 'small':
				inputGroupClassName = 'input-group-sm';
				break;
			case 'large':
				inputGroupClassName = 'input-group-lg';
				break;
			default:
		}

		var tooltip = this.props.help ? _react2['default'].createElement(
			_reactBootstrap.Tooltip,
			{ id: this.props.help },
			this.props.help
		) : null;
		var help = this.props.help ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-addon inputhelp', key: 'addonHelp' },
			_react2['default'].createElement(
				_reactBootstrap.OverlayTrigger,
				{ placement: 'top', overlay: tooltip },
				_react2['default'].createElement('span', { className: 'fa fa-question-circle' })
			)
		) : null;

		return addonBefore || addonAfter || buttonBefore || buttonAfter || help ? _react2['default'].createElement(
			'div',
			{ className: _classnames2['default'](inputGroupClassName, 'input-group'), key: 'input-group' },
			addonBefore,
			buttonBefore,
			children,
			addonAfter,
			buttonAfter,
			help
		) : children;
	};

	TextInput.prototype.renderIcon = function renderIcon() {
		if (this.props.hasFeedback) {
			if (this.props.feedbackIcon) {
				return _react2['default'].cloneElement(this.props.feedbackIcon, { formControlFeedback: true });
			}

			switch (this.props.bsStyle) {
				case 'success':
					return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'ok', key: 'icon' });
				case 'warning':
					return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'warning-sign', key: 'icon' });
				case 'error':
					return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'remove', key: 'icon' });
				default:
					return _react2['default'].createElement('span', { className: 'form-control-feedback', key: 'icon' });
			}
		} else {
			return null;
		}
	};

	TextInput.prototype.renderWrapper = function renderWrapper(children) {

		var classes = {
			'has-error': this.getError()
		};

		return _react2['default'].createElement(
			'span',
			{ className: _classnames2['default'](classes, this.props.wrapperClassName), key: 'wrapper' },
			children
		);
	};

	TextInput.prototype.renderLabel = function renderLabel(children) {
		var classes = {
			'control-label': false
		};
		classes[this.props.labelClassName] = this.props.labelClassName;

		return this.props.label ? _react2['default'].createElement(
			'label',
			{ htmlFor: this.props.id, className: _classnames2['default'](classes), key: 'label' },
			children,
			this.props.label
		) : children;
	};

	TextInput.prototype.handleReset = function handleReset(e) {
		e.stopPropagation();
		if (this.props.onChange) {
			this.props.onChange(null);
		}
		if (this.props.onBlur) {
			this.props.onBlur(null);
		}
	};

	TextInput.prototype.renderInput = function renderInput() {
		var _this = this;

		var className = 'form-control';
		if (this.props.clearable) {
			return _react2['default'].createElement(
				'div',
				{ key: 'inputw' },
				this.props.value && _react2['default'].createElement('span', { className: 'inputreset icon-cross', onClick: function (e) {
						return _this.handleReset(e);
					} }),
				_react2['default'].createElement(_reactisForms.TextInput, _extends({}, this.props, { className: _classnames2['default'](this.props.className, className), key: 'input' }))
			);
		}
		return _react2['default'].createElement(_reactisForms.TextInput, _extends({}, this.props, { className: _classnames2['default'](this.props.className, className), key: 'input' }));
	};

	TextInput.prototype.renderError = function renderError() {
		var error = this.getError();
		return error ? _react2['default'].createElement(
			'span',
			{ className: 'error-block', key: 'error' },
			error
		) : null;
	};

	TextInput.prototype.renderChildren = function renderChildren() {
		return [
		//this.renderLabel(),
		this.renderWrapper([this.renderInputGroup(this.renderInput()), this.renderIcon(), this.renderError()])];
	};

	TextInput.prototype.render = function render() {
		var children = this.renderChildren();
		return _react2['default'].createElement(
			'span',
			null,
			children
		);
	};

	_createClass(TextInput, null, [{
		key: 'filterDelay',
		value: true,
		enumerable: true
	}]);

	var _TextInput = TextInput;
	TextInput = _wrapComponent('_$TextInput')(TextInput) || TextInput;
	return TextInput;
})(_react2['default'].Component);

TextInput.propTypes = {
	type: _react2['default'].PropTypes.string,
	label: _react2['default'].PropTypes.node,
	help: _react2['default'].PropTypes.node,
	addonBefore: _react2['default'].PropTypes.node,
	addonAfter: _react2['default'].PropTypes.node,
	buttonBefore: _react2['default'].PropTypes.node,
	buttonAfter: _react2['default'].PropTypes.node,
	bsSize: _react2['default'].PropTypes.oneOf(['small', 'medium', 'large']),
	bsStyle: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	hasFeedback: _react2['default'].PropTypes.bool,
	feedbackIcon: _react2['default'].PropTypes.node,
	id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	groupClassName: _react2['default'].PropTypes.string,
	wrapperClassName: _react2['default'].PropTypes.string,
	labelClassName: _react2['default'].PropTypes.string,
	disabled: _react2['default'].PropTypes.bool,
	value: _react2['default'].PropTypes.any
};

TextInput.defaultProps = {
	type: 'text',
	disabled: false,
	hasFeedback: false
};

exports['default'] = TextInput;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/TextInput.js
 ** module id = 245
 ** module chunks = 1
 **/